import React, { useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import { Tooltip } from 'bootstrap'

const LogoTooltip = ({ title, className, children }) => {
    const ref = useRef(null)

    useEffect(() => {
        if (!ref.current || !title) return

        const tooltip = new Tooltip(ref.current, {
            title,
            placement: 'bottom',
            trigger: 'hover',
            container: 'body',
        })

        return () => tooltip.dispose()
    }, [title])

    return (
        <span ref={ref} className={className}>
            {children}
        </span>
    )
}

const CustomerLogos = ({ customers }) => {
    if (!customers?.length) return null

    const hasMultiple = customers.length > 1

    return (
        <div className={`relative z-20 flex items-center ${hasMultiple ? 'group/logos' : ''}`}>
            {customers.map((customer, index) => (
                <LogoTooltip
                    key={customer.customer_name ?? index}
                    title={customer.customer_name}
                    className={`inline-flex shrink-0 w-10 h-10 rounded-full overflow-hidden border-2 border-white transition-all duration-300 ease-in-out relative hover:z-10 ${
                        hasMultiple && index > 0
                            ? '-ml-3 group-hover/logos:ml-1.5'
                            : ''
                    }`}
                >
                    <img
                        src={customer.customer_logo_path}
                        alt={customer.customer_name ?? ''}
                        className='block w-full h-full object-cover'
                    />
                </LogoTooltip>
            ))}
        </div>
    )
}

const CampaignCard = ({ item, type }) => {

    if (type === "top") {


        return (
            <div className='max-w-[205px] h-96 border rounded-2xl relative overflow-hidden'>
                <div className='absolute top-2 left-2'>
                    <img src={item?.customer_logo_path} alt='' className='w-10 h-10 rounded-full' />
                </div>
                <img src={item?.campaign_poster_path} alt='' className='object-cover w-full h-[80%]' />
                <div className='h-[20%] w-full  p-2 '>
                    <div className='flex flex-col items-center'>

                        <h6>
                            {item?.campaign_name}
                        </h6>
                        <p>Reported Links : {item.reported}</p>
                    </div>
                </div>
            </div>
        )
    }
    if (type === "active") {
        return (
            <Link to={`/campaigns-analytics/${item.id}`}>
                <div className='max-w-[205px] h-96 border rounded-2xl relative overflow-hidden'>
                    <div className='absolute top-2 left-2'>
                        <CustomerLogos customers={item?.customers} />
                    </div>
                    <img src={item?.campaign_poster_path} alt='' className='object-cover w-full h-[80%]' />
                    <div className='h-[20%] w-full  p-2 flex flex-col gap-2'>
                        <h6 className=' m-0'>
                            {item?.campaign_name}
                        </h6>
                        <div>
                            {item?.campaign_status ? <span className="badge bg-success">Active</span> : <span className="badge bg-warning">InActive</span>}
                        </div>
                    </div>
                </div>
            </Link>
        )
    }
}

export default CampaignCard